import React, { memo } from 'react';
import {
  IconPackage,
  IconDelivery,
  IconPassed,
  IconClose,
} from '@redlink/components/atoms';

export const OrderItemStatusIcon = memo(({ status, color, size }) => {
  switch (status) {
    case 'new':
      return null;
    case 'packaging':
      return <IconPackage {...{ color }} />;
    case 'delivery':
      return <IconDelivery {...{ color }} />;
    case 'done':
      return <IconPassed {...{ color }} />;
    case 'cancel':
      return <IconClose {...{ color }} />;
    default:
      return null;
  }
});
